// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 29) return "static/js/349bbce0ec20b3cb9909.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"0f9347e08ee80d3decb3","148":"3699aee503009fef4601","149":"9a43a6b7e3237af9d52e"}[chunkId] + ".chunk.js";
};